/** Years of experience shown in all marketing copy (e.g. “12+ years”). */
export const EXPERIENCE_YEARS_DISPLAY = 12;

export function yearsOfExperienceForDisplay() {
  return EXPERIENCE_YEARS_DISPLAY;
}

/** Used in headlines like “Since …” (clinic / brand story). */
export const EXPERIENCE_START_YEAR = 2019;
